import {
  SlDropdown
} from "./chunk.C56A5M6T.js";

// src/components/dropdown/dropdown.ts
var dropdown_default = SlDropdown;
SlDropdown.define("sl-dropdown");

export {
  dropdown_default
};
